/* eslint-disable no-nested-ternary */
import { isBoolean } from 'lodash';
import React from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

interface Props extends ViewProps {
  children?: any;
  flex?: number | boolean;
  align?: 'middle' | 'center';
  backgroundColor?: string | null | undefined;
  borderRadius?: number | null | undefined;
  padding?: number | string;
  paddingLeft?: number;
  paddingRight?: number;
  paddingTop?: number;
  paddingBottom?: number;
  paddingVertical?: number;
  paddingHorizontal?: number | string;
  margin?: number | string;
  marginHorizontal?: number | string;
  marginVertical?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  marginTop?: number | string;
  marginBottom?: number | string;
  width?: number | string;
  height?: number | string;
}

export const Container = React.forwardRef((props: Props, ref: any) => {
  const {
    style,
    flex,
    align,
    backgroundColor,
    borderRadius,
    height,
    width,
    padding,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingHorizontal,
    paddingVertical,
    margin,
    marginHorizontal,
    marginVertical,
    marginBottom,
    marginTop,
    marginLeft,
    marginRight,
    children,
    ...otherProps
  } = props;

  const flexStyle = flex ? (isBoolean(flex) ? { flex: 1 } : { flex }) : null;

  const alignStyle =
    align === 'middle'
      ? { justifyContent: 'center' }
      : align === 'center'
      ? { alignItems: 'center', justifyContent: 'center' }
      : null;

  return (
    <View
      ref={ref}
      style={[
        styles.wrapper,
        flexStyle,
        alignStyle,
        backgroundColor ? { backgroundColor } : null,
        borderRadius ? { borderRadius } : null,
        {
          padding,
          paddingTop,
          paddingBottom,
          paddingLeft,
          paddingRight,
          paddingHorizontal,
          paddingVertical,
        },
        {
          margin,
          marginHorizontal,
          marginVertical,
          marginBottom,
          marginTop,
          marginLeft,
          marginRight,
        },
        !!width && { width },
        !!height && { height },
        style,
      ]}
      {...otherProps}>
      {children}
    </View>
  );
});

const styles = StyleSheet.create({
  wrapper: {},
});
